import { render, staticRenderFns } from "./JMultiSelect.vue?vue&type=template&id=372fdcbc&scoped=true&"
import script from "./JMultiSelect.vue?vue&type=script&lang=js&"
export * from "./JMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372fdcbc",
  null
  
)

export default component.exports